import { InflowAnalyticsApi } from "@/apis/v2/InflowAnalyticsApi";
import { useQuery } from "@tanstack/react-query";

const QUERY_KEY = 'InflowAnalytics';

// 볼 때마다 최신 집계를 보여주도록 탭을 열거나 기간을 바꿀 때 다시 불러온다 (기본 staleTime: Infinity 무시)
export function useInflowAnalyticsQuery({ userPageId, from, to }) {
    return useQuery({
        queryKey: [QUERY_KEY, userPageId, from, to],
        enabled: !!userPageId,
        staleTime: 0,
        queryFn: async () => {
            const response = await InflowAnalyticsApi.getInflowAnalytics({ userPageId, params: { from, to } });

            return response?.data?.data;
        },
    });
}

export function useInflowLinkQuery({ userPageId, linkItemId, from, to, enabled = true }) {
    return useQuery({
        queryKey: [QUERY_KEY, 'link', userPageId, linkItemId, from, to],
        enabled: enabled && !!userPageId && !!linkItemId,
        staleTime: 0,
        queryFn: async () => {
            const response = await InflowAnalyticsApi.getLinkAnalytics({ userPageId, linkItemId, params: { from, to } });

            return response?.data?.data;
        },
    });
}
